// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var DashboardTurnoversController = function ($scope, $http, DashboardTurnovers) {
    //$scope.turnovers = DashboardTurnovers.query({});//{ search: $scope.search });

    $scope.updateFilter = function (search) {
        $scope.turnovers = DashboardTurnovers.query({ search: $scope.search });
    }

    $scope.getCount = function (turnover) {
        $http({
            method: "GET",
            url: "/api/v1/Dashboard/turnovers/count",
            params: { search: turnover.EntityId },
        }).success(function (data) {
            turnover.ActiveCustomerCount = data.Count;
        });
    }

    /*$scope.filter = function (item) {
        return !$scope.filterTurnover || ($scope.filterTurnover && item.Total > 0);
    }*/
};
DashboardTurnoversController.$inject = ['$scope', '$http', 'DashboardTurnovers'];
